import {useLocation, useNavigate} from 'react-router-dom';
import {StepperComponent as Stepper} from '../components/stepper/Stepper';
import {FREE_PLAN_NAMES} from '../../constants/plan';
import {ROUTE_PREFIX} from '../routes/new-routes';
import {useAccountSignup} from '../contexts/AccountSignupContext';

const LOGO_IMAGE_PATH = '/assets/images/logo.svg';

const ACCOUNT_CREATION_STEPS = [
  {
    id: 'account',
    name: 'Account',
    showTooltip: false,
  },
  {
    id: 'billing',
    name: 'Billing',
    showTooltip: false,
  },
];

interface NavbarProps {
  transparentBackground?: boolean;
}

export const Navbar = ({transparentBackground = false}: NavbarProps) => {
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const {formValues} = useAccountSignup();
  const isFreePlan = FREE_PLAN_NAMES.includes(formValues.selectedPlan.type);
  const isAccountCreationStep =
    pathname.startsWith(`${ROUTE_PREFIX}/signup/create-account`) ||
    pathname.startsWith(`${ROUTE_PREFIX}/signup/verify-email`) ||
    pathname.startsWith(`${ROUTE_PREFIX}/signup/create-password`);
  const isBillingStepRoute = pathname.startsWith(
    `${ROUTE_PREFIX}/signup/billing`
  );
  const isChangePlanRoute =
    pathname.startsWith(`${ROUTE_PREFIX}/change-plan`) ||
    pathname.startsWith(`${ROUTE_PREFIX}/view-plans`);
  const showStepper =
    (isAccountCreationStep || isBillingStepRoute) && !isFreePlan;

  const currentStepId = isBillingStepRoute ? 'billing' : 'account';

  return (
    <header
      className="pt-3 md:pt-0 px-4 md:px-10 grid grid-cols-[1fr_auto_1fr] md:grid-rows-1 grid-rows-[auto_auto] items-center gap-y-6 md:gap-y-0 h-auto md:h-[104px] shrink-0"
      style={{
        background: transparentBackground ? 'transparent' : '#ffffff',
        borderBottom: transparentBackground ? 'none' : '1px solid #EFF0F1',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <button
        id="st-logo"
        onClick={() => {
          if (isChangePlanRoute) {
            window.location.href = window.homeUrl ?? ROUTE_PREFIX;
          } else {
            navigate(ROUTE_PREFIX);
          }
        }}
        aria-label="Go back to the main page"
        className="h-10 cursor-pointer border-0 bg-transparent p-0 justify-self-start"
        type="button"
        style={{background: 'none'}}
      >
        <img
          src={LOGO_IMAGE_PATH}
          alt="socialtables logo"
          className="h-10 block"
          fetchPriority="high"
        />
      </button>
      <div className="flex justify-center w-full md:w-fit col-[1/-1] md:col-[2/3] md:justify-self-center row-start-2 md:row-start-auto pb-2 md:pb-0">
        {showStepper ? (
          <Stepper
            currentStepId={currentStepId}
            steps={ACCOUNT_CREATION_STEPS}
          />
        ) : null}
      </div>
      <div className="opacity-0 pointer-events-none" aria-hidden="true">
        <img src={LOGO_IMAGE_PATH} alt="" className="h-10 block" />
      </div>
    </header>
  );
};
